<script setup>
import { useBiStore } from '~/bi/store/bi.store';
import { useCommonImports } from '~/common/composables/common-imports.composable';
import TerraBarcodeScan from '~/terra/components/barcode-scan/terra-barcode-scan.vue';
import TerraCharts from '~/terra/components/charts/terra-charts.vue';
import { useTerraStore } from '~/terra/store/terra.store.js';

const props = defineProps({
  isSidebarHidden: {
    type: Boolean,
    default: false,
  },
});

// Standard dashboard = One of the existing pages that we already have. At the time of documenting this, it includes 1. Terra charts 2. Scan report

const { route } = useCommonImports();
const bi_store = useBiStore();

const dashboard = bi_store.selected_dashboard_details;
const module = dashboard?.widgets?.module;
const map_id = dashboard?.widgets?.data?.id;
const store_name = `bi_standard_dashboard_${dashboard?.uid}`;

const terra_store = useTerraStore(store_name);

const width_class = computed(() => {
  if (props.isSidebarHidden)
    return '!w-[calc(100vw-15px)]';
  return '!w-[calc(100vw-325px)]';
});

onMounted(async () => {
  if (!terra_store.container && map_id) {
    await terra_store.set_container({
      uid: map_id,
      type: 'terra',
    });
    if (module === 'maps') {
      await terra_store.set_terra_workflows({
        asset_id: route.params.asset_id,
      });
    }
  }
});
</script>

<template>
  <div>
    <TerraCharts
      v-if="module === 'maps' && terra_store.container"
      type="terra-charts-dashboard"
      :terra_store_name="store_name"
      :add_classes="width_class"
    />
    <TerraBarcodeScan
      v-else-if="module === 'scan-report' && terra_store.container"
      :class="width_class"
      :terra_store_name="store_name"
      :is-scan-report-dashboard="true"
    />
  </div>
</template>
